import styled from "styled-components";
import Wrapper from "../atoms/Wrapper";

export const Badge = styled(Wrapper)`
  position: relative;
  width: 180px;
  height: 180px;

  @media (max-width: 450px) {
    width: 120px;
    height: 120px;
  }
`;

export const BadgeContent = styled(Wrapper)`
  position: absolute;
  bottom: 0;
  right: -5px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-size: 0.9rem;

  flex-wrap: wrap;
  font-weight: bold;

  color: ${(props) =>
    props.rank <= 3 ? props.theme.colors.white : props.theme.colors.gray};
  background: ${(props) =>
    props.rank <= 3 ? props.theme.colors.primary : props.theme.colors.white};

  box-shadow: 0 2px 6px
    ${(props) =>
      props.rank <= 3 ? props.theme.colors.primary : props.theme.colors.shadow};

  @media (max-width: 450px) {
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
    font-size: 0.9rem;
  }
`;

export const make_ranking = (items, item_to_value_func) => {
  let prev_val = item_to_value_func(items[0]);
  let curr_rank = 1;
  const ranks = items.map((_, idx) => idx + 1);

  for (let i = 1; i < items.length; ++i) {
    const val = item_to_value_func(items[i]);
    if (prev_val !== val) {
      curr_rank = i + 1;
    }
    ranks[i] = curr_rank;
    prev_val = val;
  }
  return ranks;
};
